import React, { useState, useEffect, useContext } from 'react';
import StateContext from '../../helpers/ContextState';
import { PostAsync, format } from '../../helpers/Functions';
import Config from '../../helpers/Config';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEdit, faCheck } from '@fortawesome/free-solid-svg-icons';
import Input from '../../components/InputSimple';
import SelectorMultiple from '../../components/SelectorMultiple';

const SEMESTRES_DATA = [
  { value: '1', label: 'Semestre 1 (Ene–Jun)' },
  { value: '2', label: 'Semestre 2 (Jul–Dic)' },
];

const ASOCIADO_DATA = [
  { value: '1', label: 'Asociado' },
  { value: '0', label: 'No asociado' },
];

const PERIODICIDAD_DATA = [
  { value: 'Semanal',      label: 'Semanal' },
  { value: 'Quincenal',    label: 'Quincenal' },
  { value: 'Mensual',      label: 'Mensual' },
  { value: 'Por_factura',  label: 'Por factura' },
];

const STORAGE_KEY = 'rebate_filters_v1';

const loadSaved = (key, def) => {
  try {
    const saved = sessionStorage.getItem(STORAGE_KEY);
    return saved ? (JSON.parse(saved)[key] ?? def) : def;
  } catch { return def; }
};

const App = () => {
  const context = useContext(StateContext);

  const [data, setData]                 = useState([]);
  const [totalizacion, setTotalizacion] = useState({});
  const [proveedores, setProveedores]   = useState([]);
  const [productos, setProductos]       = useState([]);
  const [marcas, setMarcas]             = useState([]);
  const [plantas, setPlantas]           = useState([]);
  const [anios, setAnios]               = useState([]);
  const [loading, setLoading]           = useState(false);

  const [inputs, setInputs]   = useState(() => loadSaved('inputs', { fecha_inicio: '', fecha_fin: '' }));
  const [inputs2, setInputs2] = useState(() => loadSaved('inputs2', {}));

  const [modalOpen, setModalOpen]           = useState(false);
  const [editRow, setEditRow]               = useState(null);
  const [valorEdit, setValorEdit]           = useState('');
  const [conceptoEdit, setConceptoEdit]     = useState('');
  const [usaKilosEdit, setUsaKilosEdit]     = useState(1);
  const [periodicidadEdit, setPeriodicidadEdit] = useState('');
  const [savingEdit, setSavingEdit]         = useState(false);
  const [msgEdit, setMsgEdit]               = useState('');

  const [modalMasivo, setModalMasivo]       = useState(false);
  const [selectedRows, setSelectedRows]     = useState({});
  const [valorMasivo, setValorMasivo]       = useState('');
  const [conceptoMasivo, setConceptoMasivo] = useState('');
  const [savingMasivo, setSavingMasivo]     = useState(false);

  useEffect(() => {
    PostAsync('Informes', 'GetAniosCompras', {}, context).then((res) => {
      if (res && !res.error && res.data) setAnios(res.data);
    });
  }, []);

  useEffect(() => {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ inputs, inputs2 })); } catch {}
    getInit();
  }, [inputs, inputs2]);

  const getFiltroMultiple = () => {
    const { semestre, anio, periodicidad_pago, ...resto } = inputs2;
    return resto;
  };

  const getSemestreParam    = () => (inputs2.semestre         || []).map(o => o.value).join(',');
  const getAnioParam        = () => (inputs2.anio             || []).map(o => o.value).join(',');
  const getPeriodicidadParam= () => (inputs2.periodicidad_pago|| []).map(o => o.value).join(',');

  const getInit = () => {
    setLoading(true);
    setData([]);
    PostAsync('Informes', 'ListadoRebate', {
      ...inputs,
      semestre:          getSemestreParam(),
      anio:              getAnioParam(),
      periodicidad_pago: getPeriodicidadParam(),
      filtroMultiple:    JSON.stringify(getFiltroMultiple()),
    }, context).then((res) => {
      setLoading(false);
      if (!res || res.error) return;
      if (res.data) {
        setData(res.data.rows || []);
        setProveedores(res.data.proveedores || []);
        setProductos(res.data.productos    || []);
        setMarcas(res.data.marcas          || []);
        setPlantas(res.data.plantas        || []);
      }
      if (res.totalizacion) setTotalizacion(res.totalizacion);
    });
  };

  const onChangeCustom = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const getRowStyle = (row) => {
    if (row.pagado_rebate == 1) return { borderLeft: '4px solid #27ae60', background: '#eafaf1' };
    switch (row.caso) {
      case 'sin_compras':    return { borderLeft: '4px solid #e1b12c' };
      case 'pendiente_pago': return { borderLeft: '4px solid #0652DD' };
      default:               return {};
    }
  };

  const onEditOpen = (row) => {
    setEditRow(row);
    setValorEdit(row.valor_unitario || '0');
    setConceptoEdit(row.concepto || '');
    setUsaKilosEdit(row.usa_kilos != null ? parseInt(row.usa_kilos) : 1);
    setPeriodicidadEdit(row.periodicidad_pago || '');
    setMsgEdit('');
    setModalOpen(true);
  };

  const onEditSave = () => {
    if (!editRow) return;
    setSavingEdit(true);
    PostAsync('Informes', 'GuardarValorUnitarioRebate', {
      proveedor_id:           editRow.proveedor_id,
      op_inventario_items_id: editRow.op_inventario_items_id,
      valor_unitario:         valorEdit,
      concepto:               conceptoEdit,
      usa_kilos:              usaKilosEdit,
      periodicidad_pago:      periodicidadEdit,
    }, context).then((res) => {
      setSavingEdit(false);
      if (!res || res.error) { setMsgEdit('Error: ' + (res?.message || '')); return; }
      setModalOpen(false);
      getInit();
    });
  };

  const onTogglePagado = (row) => {
    PostAsync('Informes', 'GuardarPagadoRebate', {
      proveedor_id:           row.proveedor_id,
      op_inventario_items_id: row.op_inventario_items_id,
      pagado_rebate:          row.pagado_rebate == 1 ? 0 : 1,
    }, context).then((res) => {
      if (!res || res.error) return;
      getInit();
    });
  };

  const toggleSelectRow = (idx) => {
    setSelectedRows(prev => ({ ...prev, [idx]: !prev[idx] }));
  };

  const toggleSelectAll = (e) => {
    const all = {};
    if (e.target.checked) data.forEach((_, i) => { all[i] = true; });
    setSelectedRows(all);
  };

  const onMasivoSave = () => {
    const seleccionados = data.filter((_, idx) => selectedRows[idx]);
    if (seleccionados.length === 0) return;
    setSavingMasivo(true);
    PostAsync('Informes', 'GuardarMasivoRebate', {
      valor_unitario: valorMasivo,
      concepto:       conceptoMasivo,
      registros:      JSON.stringify(seleccionados.map(r => ({
        proveedor_id:           r.proveedor_id,
        op_inventario_items_id: r.op_inventario_items_id,
      }))),
    }, context).then((res) => {
      setSavingMasivo(false);
      if (!res || res.error) return;
      setModalMasivo(false);
      setSelectedRows({});
      getInit();
    });
  };

  const buildPdfQuery = () => {
    let uri = '';
    if (inputs.fecha_inicio) uri += '&fecha_inicio=' + inputs.fecha_inicio;
    if (inputs.fecha_fin)    uri += '&fecha_fin='    + inputs.fecha_fin;
    const sem  = getSemestreParam();
    const anio = getAnioParam();
    if (sem)  uri += '&semestre=' + sem;
    if (anio) uri += '&anio='    + anio;
    const filtro = getFiltroMultiple();
    Object.entries(filtro).forEach(([, arr]) => {
      if (arr && arr.length > 0) arr.forEach((item) => { uri += '&' + item.name + '[]=' + item.value; });
    });
    const filtroJson = JSON.stringify(filtro);
    if (filtroJson !== '{}') uri += '&filtroMultiple=' + encodeURIComponent(filtroJson);
    return uri;
  };

  const getPdfUrl = () => {
    const q = buildPdfQuery().replace(/^&/, '');
    const base = Config.ConfigApirest + 'PDF/Informes/ListadoRebate/' + context.user.token;
    return q ? base + '?' + q : base;
  };

  const excelBaseUrl = Config.ConfigApirest + 'Excel/Informes/ListadoRebateExcel/token:' + context.user.token;

  const openExcel = (e) => {
    e.preventDefault();
    let uri = e.target.href + '?';
    if (inputs.fecha_inicio) uri += 'fecha_inicio=' + inputs.fecha_inicio + '&';
    if (inputs.fecha_fin)    uri += 'fecha_fin='    + inputs.fecha_fin    + '&';
    Object.entries(inputs2).forEach(([, arr]) => {
      if (arr && arr.length > 0) arr.forEach((item) => { uri += item.name + '[]=' + item.value + '&'; });
    });
    window.open(uri);
  };

  const emptyTds    = (n) => Array.from({ length: n }).map((_, i) => <td key={i}></td>);
  const cxpDisplay  = (val) => (val && val !== '—') ? val : '';
  const someSelected = Object.values(selectedRows).some(Boolean);
  const selectedCount = Object.values(selectedRows).filter(Boolean).length;
  const rebateBase  = (row) => row.usa_kilos == 1 ? row.kilos_total_format : (row.cantidad_total_format || row.cantidad_total);

  return (
    <div className="container-fluid" style={{ marginTop: '60px' }}>

      <div className="row mb-2">
        <div className="col d-flex justify-content-end gap-2 flex-wrap">
          {someSelected && (
            <button className="btn btn-success btn-sm" onClick={() => setModalMasivo(true)}>
              Actualizar seleccionados ({selectedCount})
            </button>
          )}
          <a className="btn btn-secondary btn-sm" href={excelBaseUrl} target="_blank" onClick={openExcel}>Exportar</a>
          <a className="btn btn-primary btn-sm" href={getPdfUrl()} target="_blank" rel="noreferrer">PDF</a>
        </div>
      </div>

      <div className="row bg-gray small">
        <div className="col-12 small mb-1"><b>Filtros de búsqueda — Informe Rebate</b></div>

        <div className="col-12 col-sm-2 mb-2 pt-1">
          <Input defaultValue={inputs.fecha_inicio} title="Fecha compra desde" placeholder="Fecha desde"
            type="date" name="fecha_inicio" className="form-control form-control-sm" onChange={onChangeCustom} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <Input defaultValue={inputs.fecha_fin} title="Fecha compra hasta" placeholder="Fecha hasta"
            type="date" name="fecha_fin" className="form-control form-control-sm" onChange={onChangeCustom} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <SelectorMultiple name="semestre" title="Semestre" selectDefault="Semestre"
            data={SEMESTRES_DATA} inputs={inputs2} setInputs={setInputs2} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <SelectorMultiple name="anio" title="Año" selectDefault="Año"
            data={anios} inputs={inputs2} setInputs={setInputs2} />
        </div>
        <div className="col-12 col-sm-3 mb-2 pt-1">
          <SelectorMultiple name="proveedor_id" title="Proveedor" selectDefault="Proveedor"
            data={proveedores} inputs={inputs2} setInputs={setInputs2} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <SelectorMultiple name="op_inventario_items_id" title="Producto" selectDefault="Producto"
            data={productos} inputs={inputs2} setInputs={setInputs2} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <SelectorMultiple name="marca_id" title="Marca" selectDefault="Marca"
            data={marcas} inputs={inputs2} setInputs={setInputs2} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <SelectorMultiple name="planta_id" title="Planta" selectDefault="Planta"
            data={plantas} inputs={inputs2} setInputs={setInputs2} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <SelectorMultiple name="es_asociado" title="Tipo proveedor" selectDefault="Asociado / No asociado"
            data={ASOCIADO_DATA} inputs={inputs2} setInputs={setInputs2} />
        </div>
        <div className="col-12 col-sm-2 mb-2 pt-1">
          <SelectorMultiple name="periodicidad_pago" title="Periodicidad" selectDefault="Periodicidad de pago"
            data={PERIODICIDAD_DATA} inputs={inputs2} setInputs={setInputs2} />
        </div>
      </div>

      <div className="row mt-2 mb-1">
        <div className="col small text-muted">
          <span style={{ borderLeft: '4px solid #27ae60', paddingLeft: '6px', marginRight: '12px' }}>
            Rebate marcado como pagado (chuleado ✓)
          </span>
          <span style={{ borderLeft: '4px solid #0652DD', paddingLeft: '6px', marginRight: '12px' }}>
            Pendiente de facturar/pagar
          </span>
          <span style={{ borderLeft: '4px solid #e1b12c', paddingLeft: '6px' }}>
            Sin compras registradas
          </span>
        </div>
      </div>

      <div className="row">
        <div className="col">
          {loading ? (
            <div className="text-center py-5"><div className="spinner-border text-secondary" role="status" /></div>
          ) : data.length === 0 ? (
            <div className="alert alert-info mt-3">No hay registros para mostrar.</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table className="table table-striped table-sm">
                <thead>
                  <tr>
                    <th style={{ width: '30px' }}>
                      <input type="checkbox" onChange={toggleSelectAll} />
                    </th>
                    <th className="text-left small">Proveedor</th>
                    <th className="text-center small">NIT</th>
                    <th className="text-center small">Tipo</th>
                    <th className="text-center small">Resp. IVA</th>
                    <th className="text-center small">Semestre</th>
                    <th className="text-left small">Producto</th>
                    <th className="text-left small">Marcas</th>
                    <th className="text-center small">Unidades</th>
                    <th className="text-center small">Kilos</th>
                    <th className="text-center small">Subtotal</th>
                    <th className="text-center small">Vr. Unit.</th>
                    <th className="text-center small">Vr. Rebate</th>
                    <th className="text-center small">IVA</th>
                    <th className="text-center small">ReteIVA</th>
                    <th className="text-center small">ReteICA</th>
                    <th className="text-center small">RetefFuente</th>
                    <th className="text-center small">P. Total</th>
                    <th className="text-center small">Concepto Rebate</th>
                    <th className="text-center small">Periodicidad</th>
                    <th className="text-center small">Estado CXP</th>
                    <th className="text-center small">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, idx) => (
                    <tr key={idx} style={getRowStyle(row)}>
                      <td className="text-center">
                        <input type="checkbox" checked={!!selectedRows[idx]} onChange={() => toggleSelectRow(idx)} />
                      </td>
                      <td className="small">{row.proveedor_nombre}</td>
                      <td className="text-center small">{row.proveedor_cedula}</td>
                      <td className="text-center small">{row.es_asociado_string}</td>
                      <td className="text-center small">{row.responsable_iva}</td>
                      <td className="text-center small">{row.semestre_label}</td>
                      <td className="small">{row.producto_nombre}</td>
                      <td className="small">{row.marca_nombre || ''}</td>
                      <td className="text-end small">{row.cantidad_total_format || row.cantidad_total}</td>
                      <td className="text-end small">{row.kilos_total_format}</td>
                      <td className="text-end small">{row.subtotal_sin_imp_string}</td>
                      <td className="text-end small">
                        {row.valor_unitario_format}
                        <span className="text-muted" style={{ fontSize: '10px', display: 'block' }}>
                          /{row.usa_kilos == 1 ? 'kg' : 'und'}
                        </span>
                      </td>
                      <td className="text-end small"><b>{row.valor_rebate_format}</b></td>
                      <td className="text-end small">{row.iva_total_string}</td>
                      <td className="text-end small">{row.calculo_reteiva}</td>
                      <td className="text-end small">{row.calculo_reteica}</td>
                      <td className="text-end small">{row.calculo_retefuente}</td>
                      <td className="text-end small"><b>{row.precio_total_rebate_string}</b></td>
                      <td className="small" title={row.concepto || ''}>{row.concepto && row.concepto.length > 15 ? row.concepto.substr(0, 15) + '...' : (row.concepto || '')}</td>
                      <td className="text-center small">{row.periodicidad_pago || ''}</td>
                      <td className="text-center small">{cxpDisplay(row.cxp_string)}</td>
                      <td className="text-center small" style={{ whiteSpace: 'nowrap' }}>
                        <button className="btn btn-warning btn-sm me-1" title="Editar valor unitario de rebate"
                          onClick={() => onEditOpen(row)}>
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <button
                          className={`btn btn-sm me-1 ${row.pagado_rebate == 1 ? 'btn-success' : 'btn-outline-secondary'}`}
                          title={row.pagado_rebate == 1 ? 'Desmarcar rebate pagado' : 'Marcar rebate como pagado'}
                          onClick={() => onTogglePagado(row)}
                        >
                          <FontAwesomeIcon icon={faCheck} />
                        </button>
                        <NavLink className="btn btn-primary btn-sm" title="Ver detalle"
                          to={`/Informes/InformesRebate/Detalle/${row.proveedor_id}/${row.op_inventario_items_id}/0`}>
                          <FontAwesomeIcon icon={faEye} />
                        </NavLink>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    {emptyTds(9)}
                    <td className="bg-secondary text-white p-1 small text-end"><b>{totalizacion.kilos_format}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{totalizacion.subtotal_sin_imp_string}</b></td>
                    <td></td>
                    <td className="bg-primary text-white p-1 small text-end"><b>{totalizacion.valor_rebate_format}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{totalizacion.iva_total_string}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{totalizacion.calculo_reteiva}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{totalizacion.calculo_reteica}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{totalizacion.calculo_retefuente}</b></td>
                    <td className="bg-primary text-white p-1 small text-end"><b>{totalizacion.precio_total_rebate_string}</b></td>
                    {emptyTds(4)}
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>
      </div>

      {modalOpen && editRow && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={(e) => { if (e.target === e.currentTarget) setModalOpen(false); }}>
          <div className="bg-white p-4" style={{ borderRadius: '4px', minWidth: '360px', maxWidth: '460px', width: '95%' }}>
            <h6 className="mb-3 border-bottom pb-2"><b>Editar Valor Unitario de Rebate</b></h6>
            <div className="small text-muted mb-3">
              <div><b>Proveedor:</b> {editRow.proveedor_nombre}</div>
              <div><b>Producto:</b>  {editRow.producto_nombre}</div>
              <div><b>Semestre:</b>  {editRow.semestre_label}
                &nbsp;&nbsp;<b>Kilos:</b> {editRow.kilos_total_format}
                &nbsp;&nbsp;<b>Unidades:</b> {editRow.cantidad_total}
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label small mb-1"><b>Multiplicar vr. unitario por</b></label>
              <div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" id="rbKilos" name="usa_kilos_modal"
                    checked={usaKilosEdit === 1} onChange={() => setUsaKilosEdit(1)} />
                  <label className="form-check-label small" htmlFor="rbKilos">Kilos</label>
                </div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" id="rbUnidades" name="usa_kilos_modal"
                    checked={usaKilosEdit === 0} onChange={() => setUsaKilosEdit(0)} />
                  <label className="form-check-label small" htmlFor="rbUnidades">Unidades</label>
                </div>
              </div>
            </div>
            <div className="mb-2">
              <label className="form-label small mb-1"><b>Valor Unitario ($ por {usaKilosEdit ? 'kg' : 'unidad'})</b></label>
              <input type="number" className="form-control form-control-sm" step="0.01" min="0"
                value={valorEdit} onChange={(e) => setValorEdit(e.target.value)} />
              <div className="text-muted small mt-1">
                Rebate estimado:&nbsp;
                <b>${format(parseFloat(valorEdit || 0) * parseFloat(usaKilosEdit ? (editRow.kilos_total || 0) : (editRow.cantidad_total || 0)))}</b>
              </div>
            </div>
            <div className="mb-2">
              <label className="form-label small mb-1"><b>Concepto pago rebate</b></label>
              <input type="text" className="form-control form-control-sm" placeholder="Concepto..."
                value={conceptoEdit} onChange={(e) => setConceptoEdit(e.target.value)} />
            </div>
            <div className="mb-3">
              <label className="form-label small mb-1"><b>Periodicidad de pago</b></label>
              <select className="form-control form-control-sm" value={periodicidadEdit}
                onChange={(e) => setPeriodicidadEdit(e.target.value)}>
                <option value="">-- Seleccionar --</option>
                {PERIODICIDAD_DATA.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
              </select>
            </div>
            {msgEdit && <div className="alert alert-danger py-1 small mb-2">{msgEdit}</div>}
            <div className="d-flex justify-content-end gap-2">
              <button className="btn btn-secondary btn-sm" onClick={() => setModalOpen(false)}>Cancelar</button>
              <button className="btn btn-primary btn-sm" onClick={onEditSave} disabled={savingEdit}>
                {savingEdit ? 'Guardando...' : 'Guardar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {modalMasivo && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={(e) => { if (e.target === e.currentTarget) setModalMasivo(false); }}>
          <div className="bg-white p-4" style={{ borderRadius: '4px', minWidth: '340px', maxWidth: '420px', width: '95%' }}>
            <h6 className="mb-3 border-bottom pb-2"><b>Actualización Masiva de Rebate</b></h6>
            <div className="small text-muted mb-3">
              Se actualizarán <b>{selectedCount}</b> registro(s) seleccionado(s).
            </div>
            <div className="mb-2">
              <label className="form-label small mb-1"><b>Valor Unitario</b></label>
              <input type="number" className="form-control form-control-sm" step="0.01" min="0"
                value={valorMasivo} onChange={(e) => setValorMasivo(e.target.value)} />
            </div>
            <div className="mb-3">
              <label className="form-label small mb-1"><b>Concepto pago rebate</b></label>
              <input type="text" className="form-control form-control-sm" placeholder="Concepto..."
                value={conceptoMasivo} onChange={(e) => setConceptoMasivo(e.target.value)} />
            </div>
            <div className="d-flex justify-content-end gap-2">
              <button className="btn btn-secondary btn-sm" onClick={() => setModalMasivo(false)}>Cancelar</button>
              <button className="btn btn-primary btn-sm" onClick={onMasivoSave} disabled={savingMasivo || selectedCount === 0}>
                {savingMasivo ? 'Guardando...' : `Aplicar a ${selectedCount} registros`}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default App;
